import axios from "axios"
import { capitalizeWords, history } from "helpers"
import { request } from "service"
import endpoints from "service/endpoints"
import { Toast } from "service/toast"
import { createElement, deleteTableData, getTableData, updateElement } from "service/utilities"

//scheme management
//get MasterScheme
export const fetchMasterScheme = async (id) => {
  try {
    const responce = await request({
      baseUrl: "reports",
      url: `${endpoints.schemeModule.viewMaster}/collection/${id}`,
      method: endpoints.APIMethods.GET,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}

//get All schemeApi detailes
// services/schemeAPI.js
export const fetchSubSchemeData = async (subSchemeId, languageIds, type = 'cms') => {
  try {
    const response = await request({
      baseUrl: "schemes",
      url: `${endpoints.schemeModule.subSchemes}/${subSchemeId}`,
      method: endpoints.APIMethods.GET,
      params: { languageIds },
    });

    const data = response?.data?.data;
    const defaultGiftImageDetails = [
      {
        id: 1,
        amount: "",
        imageslab: [{ priceImage: "", name: "", priceImageurl: "" }],
      },
    ];

    const updatedCms = data?.cms?.map((item) => {
      // Clean giftImageDetails
      const cleanedGiftImageDetails = (item?.giftImageDetails || [])
        .filter((d) => d !== null && d !== undefined) // remove nulls
        .map((d, idx) => ({
          ...d,
          id: d?.id ?? idx + 1, // replace null id with sequential index
        }));

      return {
        ...item,
        giftImageDetails:
          cleanedGiftImageDetails.length > 0
            ? cleanedGiftImageDetails
            : defaultGiftImageDetails,
      };
    });

    const updatedData = {
      ...data,
      cms: updatedCms,
    };


    if (type === 'cms') {

      if (!data?.cms?.length) {
        return {
          benefitDetails: data?.benefits
        }
      }

      const currentOldCMS = data.cms.map((lang) => ({
        languageType: lang.languageType,
        data: lang.data || [],
        bannerDetails: lang.bannerDetails || {},
        sgs8ChooseWish: lang.sgs8ChooseWish || {},
        giftImageDetails: lang.giftImageDetails || [{
          id: 1,
          amount: "",
          imageslab: [
            { priceImage: "", name: "", priceImageurl: "" },

          ],
        }],
      }));


      const formattedCmsData = currentOldCMS.map((lang) => {
        const isExistingLang = languageIds.includes(lang.languageType);
        if (!isExistingLang) {
          const previousLang = currentOldCMS?.find(
            (oldLang) => oldLang.languageType === lang.languageType
          );

          return previousLang || {
            languageType: lang.languageType,
            data: [],
            bannerDetails: {},
            sgs8ChooseWish: {},
            giftImageDetails: [{
              id: 1,
              amount: "",
              imageslab: [
                { priceImage: "", name: "", priceImageurl: "" },

              ],
            }],
          };
        }
        return lang;
      });

      return {
        originalData: updatedData,
        formattedCmsData,
        bgColor: data.bgColor,
        benefitDetails: data?.benefits
      };
    }

    if (type === 'tc') {
      const defaultTerms = [{
        languageType: "en",
        data: "",
      }];

      return {
        terms: data?.terms?.length > 0 ? data.terms : defaultTerms,
        success: true
      };
    }

  } catch (error) {
    console.error(`Error fetching sub scheme ${type} details:`, error);
    throw error;
  }
};

//Update Scheme API
export const updateSubScheme = async (subSchemeId, masterSchemeId, data) => {
  try {
    await request({
      baseUrl: "schemes",
      url: endpoints.schemeModule.subSchemes,
      method: endpoints.APIMethods.PUT,
      data: { ...data, _id: subSchemeId },
      errorToast: false,
    });

    return {
      success: true,
      redirectPath: `/scheme-management/view-master/${masterSchemeId}`
    };
  } catch (error) {
    throw new Error("Fill all the details to Proceed");
  }
};


// Customer Mangement Tab
//Gpp Info
export const fetchUserGppInfo = async (userId) => {
  try {
    const responce = await request({
      baseUrl: "users",
      url: `${endpoints.customerModule.getGppInfo}?userId=${userId}`,
      method: endpoints.APIMethods.GET,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}

//Get Kyc
export const fetchKycAPI = async (userId) => {
  try {
    const responce = await request({
      url: `${endpoints.customerModule.getKyc}?id=${userId}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "users",
      errorToast: false,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}
export const fecthBankAPI = async (userId) => {
  try {
    const responce = await request({
      url: `${endpoints.customerModule.bankDetail}?id=${userId}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "users",
      errorToast: false,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}
export const fetchAdressAPI = async (userId) => {
  try {
    const responce = await request({
      url: `${endpoints.customerModule.address}?userId=${userId}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "users",
      errorToast: false,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}
// get user data
export const FetchUserData = async (userId) => {
  try {
    const responce = await request({
      url: `${endpoints.customerModule.getProfile}?id=${userId}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "users",
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}

//Get Session Data
export const fetchSessionLogAPI = async (userId) => {
  let datum = { type: "session", userId }

  try {
    const responce = await request({
      url: `${endpoints.customerModule.getSessionDetails}`,
      method: endpoints.APIMethods.GET,
      params: datum,
    })

    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}

//Get Transaction Detailes
export const fetchTransactionDetails = async (datum) => {
  try {
    const responce = await request({
      baseUrl: "orders",
      url: `${endpoints.customerModule.transactionLog}`,
      method: endpoints.APIMethods.GET,
      params: datum,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}
//Fetch Scheme data
export const fetchSchemeData = async (userSchemeId) => {
  try {
    const responce = await request({
      url: `${endpoints.customerModule.getScheme}/${userSchemeId}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "schemes",
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}
//Get UserScheme Count
export const fetchAllSchemes = async (mobileNumber) => {
  try {
    const responce = await request({
      url: `${endpoints.reportModule.getUserSchemeCount}?mobileNumber=${mobileNumber}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "payments",
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}
// Prod To Preprod
export const Fetchprodtopreprod = async (mobileNumber) => {
  let body = {
    mobileNumber: `${mobileNumber}`,
  }
  try {
    await request({
      url: `${endpoints.schemeModule?.prodtopreprodsync}`,
      method: endpoints.APIMethods.POST,
      baseUrl: "users",
      data: body,
    })
  } catch (error) {
    console.log(error)
  }
}

export const fetchSyncPassbook = async (mobileNumber) => {
  let body = {
    mobileNumber: mobileNumber || "",
  }
  try {
    const responce = await request({
      url: endpoints.customerModule.syncpassbookfromGpp,
      baseUrl: "users",
      method: endpoints.APIMethods.POST,
      data: body,
    })
    return responce?.data
  } catch (error) {
    console.log(error)
  }
}

export const fetchRewards = async (status, mobileNumber) => {
  try {
    const responce = await request({
      url: `${endpoints.customerModule.rewardsList}?page=1&limit=1000&status=${status}&mobileNumber=${mobileNumber}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "schemes",
    })

    return responce?.data?.data?.list
  } catch (error) {
    console.log(error)
  }
}

//get Schemelist based on status
export const fetchSchemes = async (
  userId,
  status,
  schemeStatus,
  search,
  activePage
) => {
  const params = {
    userId,
    status,
    schemeStatus,
    search,
    page: activePage,
    limit: 10,
  }

  try {
    const response = await request({
      baseUrl: "schemes",
      url: `${endpoints.customerModule.getScheme}`,
      method: endpoints.APIMethods.GET,
      params,
    })
    return response.data.data
  } catch (error) {
    console.log(error)
  }
}

//Fetch the ShowRoom List
export const fetchShowroomList = async () => {
  let params = {
    limit: "1000",
    page: 1,
  }
  try {
    const responce = await request({
      url: `${endpoints.customerModule.showroomList}`,
      params,
      baseUrl: "notifications",
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}

export const fetchCustomerList = async (params) => {
  try {
    const responce = await request({
      url: endpoints.getCustomer.getCustomerList,
      params,
      method: endpoints.APIMethods.GET,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}


//fetch passbook receipt Sync
export const fetchPassbookReceiptSync = async (body) => {
  try {
    const responce = await request({
      url: `${endpoints.schemeModule?.passbookreceiptsynk}`,
      method: endpoints.APIMethods.POST,
      baseUrl: "users",
      data: body,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}

//get Session log detailes
export const fetchSessionLogTableAPI = async (datum) => {
  try {
    const responce = await request({
      url: `${endpoints.customerModule.sessionLog}`,
      method: endpoints.APIMethods.GET,
      params: datum,
    })
    return responce?.data?.data
  } catch (error) {
    console.log(error)
  }
}

//Export Csv
export const fetchExportCsv = async (id) => {
  try {
    const response = await request({
      url: `${endpoints.schemeModule.exportCsv}?userSchemeId=${id}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "schemes",
      responseType: "blob", // Add this line
    })

    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "transaction.csv")
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url) // Add this line
    }
  } catch (error) {
    console.error("Error exporting CSV:", error)
  }
}
export const fetchDownloadStatement = async (body) => {
  const POLLING_INTERVAL = 3000; // Time interval between API calls in milliseconds
  const MAX_RETRIES = 10; // Maximum number of retries

  try {
    const response = await request({
      url: `${endpoints.schemeModule.downloadPdf}`,
      method: endpoints.APIMethods.POST,
      baseUrl: "reports",
      data: body,
      errorToast: false,
    });

    const s4Url = response?.data?.data?.fileUrl;
    if (!s4Url) {
      console.error("S4 URL is empty or undefined");
      return;
    }

    const s3Url = `https://preprodpayments.thangamayil.in${s4Url}`;
    const fileName = s3Url.split("/").pop() || "downloaded_file.pdf";

    let retries = 0;

    const pollForFile = async () => {
      try {
        const res = await axios({
          url: s3Url,
          method: "GET",
          responseType: "blob", // Important for downloading files
        });

        // File is ready, proceed with download
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        console.log("File downloaded successfully");
      } catch (err) {
        // If the file is not ready yet, retry until the maximum retries are reached
        if (err.response?.status === 404 && retries < MAX_RETRIES) {
          retries++;
          console.log(`Retrying to fetch file... Attempt ${retries}`);
          setTimeout(pollForFile, POLLING_INTERVAL);
        } else {
          console.error("Error fetching the PDF file or max retries reached:", err);
        }
      }
    };

    pollForFile(); // Start polling for the file
  } catch (error) {
    console.error("Error exporting PDF:", error);
  }
};

export const getMasterSchemesList = async (series) => {
  let temp = { schemeId: "All", _id: "" }
  let params = {
    page: 1,
    limit: 100,
  }
  if (series === 1000) {
    params.scheduleAllowed = true
  }
  try {
    const response = await request({
      baseUrl: "schemes",
      url: `/schemes`,
      params,
      method: endpoints.APIMethods.GET,
    })

    const responseData = response?.data?.data?.list || []

    if (Array.isArray(responseData)) {
      responseData.unshift(temp)
    }

    return responseData
  } catch (error) {
    console.error("Error fetching schemes list:", error)
    return []
  }
}

export const getSchemeList = async (schemeType, sort, series) => {
  let params = {
    subschemename: schemeType,
    sortType: sort
  }
  if (series === 1000) {
    params.scheduleAllowed = true
  }
  try {
    const response = await request({
      baseUrl: "reports",
      url: endpoints.dashboard.getDashboardSgsList,
      method: endpoints.APIMethods.GET,
      params: params,
    })

    const formattedSchemes =
      response?.data?.data?.map((scheme) => ({
        label: scheme?.subschemename,
        value: scheme?._id,
      })) || []

    const allSelect = [{ label: "Select All", value: "" }]
    const allList = [...allSelect, ...formattedSchemes]
    return allList
  } catch (error) {
    console.error(error)
  }
}

export const getSchemeListWithId = async () => {
  let params = {
    page: 1,
    limit: 100,
    status: 1,
  }

  try {
    const response = await request({
      baseUrl: "schemes",
      url: endpoints.reportModule.getSubScheme,
      method: endpoints.APIMethods.GET,
      params: params,
    })

    // Assuming response.data.data.list contains the scheme values
    const schemeList = response?.data?.data?.list?.map((item) => ({
      label: item?.schemeId,
      value: item?._id,
    }))
    const allSelect = [{ label: "Select All", value: "" }]
    const allList = [...allSelect, ...schemeList]
    return allList // Set the mapped list to the state or use as needed
  } catch (error) {
    console.error("Error fetching scheme list:", error)
    // Handle the error (e.g., show error message in UI)
  }
}
//Reports 200 series
export const getSearchData = async (currentPage = 1, api, params) => {
  try {
    const response = await request({
      url: endpoints.reportModule[api], // Access the endpoint dynamically
      baseUrl: "reports",
      params: params,
      method: endpoints.APIMethods.GET,
    })
    return response
  } catch (error) {
    console.error("Error fetching search data:", error)
    Toast({
      type: "error",
      message: "Failed to fetch search data. Please try again.",
    })
    throw error // Optional: rethrow the error for further handling
  }
}
export const getSearchDataForSchemes = async (currentPage = 1, api, params) => {
  const method =
    api === "getPassbookDetailReport"
      ? endpoints.APIMethods.POST
      : endpoints.APIMethods.GET
  try {
    const response = await request({
      url: endpoints.reportModule[api], // Access the endpoint dynamically
      baseUrl: "reports",
      params: params,
      method: method,
    })

    return response
  } catch (error) {
    history.goBack()
    console.error("Error fetching search data:", error)

    throw error // Optional: rethrow the error for further handling
  }
}
// Common function to handle fetching data for reports
export const summaryDashboardData = async (api, params) => {
  try {
    const response = await request({
      url: endpoints.reportModule[api],
      baseUrl: "reports",
      params: params,
      method: endpoints.APIMethods.GET,
    })
    return response
  } catch (error) {
    console.error("Error fetching report data:", error)

    throw error
  }
}
// Dynamic Reason Commanly handed
//1.Get All Reasons
export const getAllReasons = async (mainCategory, subCategory) => {
  try {
    const response = await request({
      url: `${endpoints.workManagementModule.getReason}?maincategory=${mainCategory}&subcategory=${subCategory}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "notifications",
    })

    const temp = response?.data?.data?.ans?.map((ele) => ({
      ...ele,
      value: ele._id,
    }))

    return temp
  } catch (error) {
    console.error("Error fetching reasons:", error)
    Toast({
      type: "error",
      message: "Failed to fetch reasons. Please try again.",
    })
    throw error
  }
}
//2 Save Reason
export const SaveReason = async (mainCategory, subCategory, reasonName) => {
  try {
    let body = {
      reason: `${reasonName}`,
      maincategory: `${mainCategory}`,
      subcategory: `${subCategory}`,
    }
    const response = await request({
      url: endpoints.workManagementModule.addReason,
      method: endpoints.APIMethods.POST,
      baseUrl: "notifications",
      data: body,
    })

    return response
  } catch (error) {
    console.error("Error fetching report data:", error)

    throw error
  }
}
//Delete reason
export const deleteReasons = async (reasonId) => {
  try {
    let body = {
      id: reasonId,
    }
    const responce = await request({
      url: `${endpoints.workManagementModule.deleteReason}`,
      method: endpoints.APIMethods.DELETE,
      data: body,
      baseUrl: "notifications",
    })
    return responce
  } catch (error) {
    console.error("Error fetching report data:", error)

    throw error
  }
}

//Common Api For Get All Roles

export const getAllRoles = async () => {
  try {
    const response = await request({
      url: endpoints.userModule.addrole,
      method: endpoints.APIMethods.GET,
    })

    const datum = response?.data?.data?.map((ele) => ({
      ...ele,
      label: ele.name,
      value: ele._id,
    }))

    const temp = response?.data?.data?.map((ele) =>
      ele?.permissions?.map((i) => ({
        ...i,
        label: i.name,
        value: i.name,
      }))
    )

    return datum
  } catch (error) {
    console.error("Error fetching roles:", error)
    throw error
  }
}
// Get Launguage List

export const fetchLanguageList = async () => {
  try {
    const response = await request({
      url: `${endpoints.systemConfigSettingsModule.languages}`,
      baseUrl: "notifications",
      method: endpoints.APIMethods.GET,
    })

    const formattedLanguages = []
    let languageIds = ""

    response.data.data.forEach((language, index) => {
      formattedLanguages.push({
        value: language.languageId,
        label: capitalizeWords(language.name),
        languageId: language.languageId,
        name: capitalizeWords(language.name),
      })

      languageIds +=
        index === 0 ? language.languageId : `|${language.languageId}`
    })

    return { formattedLanguages, languageIds }
  } catch (error) {
    console.error("Error fetching language list:", error)
  }
}

// Content management
export const fetchSectionDetailsApi = async (historyArray) => {
  const currentSection = historyArray[historyArray.length - 1]

  try {
    const responce = await request({
      url: endpoints.contentManagementModule[currentSection],
      baseUrl: "notifications",
      method: endpoints.APIMethods.GET,
    })
    return responce?.data?.data
  } catch (error) {
    console.log("Error to Find Detailes")
  }
}
//get categoty list
export const fetchCategoryList = async (params) => {
  try {
    const response = await request({
      url: endpoints.referralManagementCatgoryModule.getCategoryListNoDropdown,
      baseUrl: "referearn",
      params: params,
      method: endpoints.APIMethods.GET,
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching category list:", error);
    throw error;
  }
};

export const fetchCategoryListData = async (params) => {
  try {
    const response = await request({
      url: endpoints.referralManagementCatgoryModule.getCategoryList,
      baseUrl: "referearn",
      params: params,
      method: endpoints.APIMethods.GET,
    })
    return response?.data?.data
  } catch (error) {
    console.error("Error fetching category list:", error)
    throw error
  }
}
export const updateTheCategotyStatus = async (params) => {
  try {
    const response = await request({
      url: endpoints.referralManagementCatgoryModule.updateCategoryStatus,
      baseUrl: "referearn",
      params: params,
      method: endpoints.APIMethods.POST,
    })
    return response?.data?.data
  } catch (error) {
    console.error("Error fetching category list:", error)
    throw error
  }
}
export const fetchFaqList = async (params) => {
  try {
    const response = await request({
      url: endpoints.referralManagementFaq.getFaqList,
      baseUrl: "referearn",
      params: params,
      method: endpoints.APIMethods.GET,
    })
    return response?.data?.data
  } catch (error) {
    console.error("Error  fetchFaqList list:", error)
    throw error
  }
}
export const createFaqList = async (body) => {
  try {
    const response = await request({
      url: endpoints.referralManagementFaq.createFaq,
      baseUrl: "referearn",
      data: body,
      method: endpoints.APIMethods.POST,
    })
    return response?.data?.data
  } catch (error) {
    console.error("Error  fetchFaqList list:", error)
    throw error
  }
}

export const getAllPassbooksofTheCustomer = async (params) => {

  try {
    const response = await request({
      url: endpoints.receiptReconciliation.getPassbooksoftheCustomer,
      method: endpoints.APIMethods.GET,
      baseUrl: "schemes",
      params: params

    })

    const subschemeIds = response?.data?.data?.length
      ? response?.data?.data?.map((ele) => ({

        label: ele.subSchemeUniqueId,
        value: ele.subSchemeUniqueId,
      }))
      : [];

    const passbookIds = response?.data?.data?.length
      ? response?.data?.data?.map((ele) => ({

        label: ele.userSchemePassbookId,
        value: ele.userSchemePassbookId,
      }))
      : [];

    const responce = response?.data?.data
    const uniqueArraySubSchemeIds = subschemeIds?.filter(
      (obj, index, self) => index === self?.findIndex((o) => o.value === obj.value)
    );
    const uniqueArrayPassbookIds = passbookIds?.filter(
      (obj, index, self) => index === self?.findIndex((o) => o.value === obj.value)
    );
    return { uniqueArraySubSchemeIds, uniqueArrayPassbookIds, responce }
  } catch (error) {
    console.error("Error fetching roles:", error)
    throw error
  }
}
export const fetchAllCampaigns = async () => {
  try {
    let temp = { campaignId: "All", _id: "" };

    const response = await request({
      url: endpoints.referralManagementCatgoryModule.getAllCampaignList,
      baseUrl: "notifications",
      method: endpoints.APIMethods.GET,
    });

    const responseData = response?.data?.data || [];

    if (Array.isArray(responseData)) {
      responseData.unshift(temp);
    }

    return responseData;
  } catch (error) {
    console.error("Error fetching campaign list:", error);
    return [];
  }
};
export const getPosReport = async (params) => {
  try {
    const response = await request({
      url: endpoints.reportModule.getPosReport, // Access the endpoint dynamically
      baseUrl: "reports",
      params: params,
      method: endpoints.APIMethods.GET,
    })

    return response
  } catch (error) {
    history.goBack()
    console.error("Error fetching search data:", error)

    throw error // Optional: rethrow the error for further handling
  }
}
export const fetchCrmTableData = async (params, tabKey) => {

  try {
    const response = await request({
      url: `${getTableData(tabKey)}`,
      baseUrl: "crm",
      params: params,
      method: endpoints.APIMethods.GET,
    })

    return response?.data?.data
  } catch (error) {
    console.error("Error  fetchFaqList list:", error)
    throw error
  }
}


export const postCrmTableData = async (params, tabKey) => {
  try {
    const response = await request({
      url: createElement(tabKey),
      baseUrl: "crm",
      data: params,
      method: endpoints.APIMethods.POST,
    })
    return response?.data
  } catch (error) {
    console.error("Error  fetchFaqList list:", error)
    throw error
  }
}


export const updateCrmTableData = async (params, tabKey) => {
  try {
    const response = await request({
      url: updateElement(tabKey),
      baseUrl: "crm",
      data: params,
      method: endpoints.APIMethods.PUT,
    })
    return response?.data
  } catch (error) {
    console.error("Error updating CRM table data:", error)
    throw error
  }
}


export const deleteCrmTableData = async (id, tabKey) => {
  try {
    const response = await request({
      url: deleteTableData(tabKey),
      data: { id: id },
      baseUrl: "crm",
      method: endpoints.APIMethods.DELETE,
    })
    return response?.data
  } catch (error) {
    console.error("Error deleting CRM table data:", error)
    throw error
  }
}

export const uploadCRMFile = async (formData) => {
  try {
    const response = await request({
      url: endpoints.crmUpload.upload,
      baseUrl: "crm",
      method: endpoints.APIMethods.POST,
      data: formData,
      contentType: "multipart/form-data"
    })
    return response
  } catch (err) {
    console.error("Error uploading file", err)
    throw err
  }
}
export const refundAuthpayment = async (data) => {
  try {
    const response = await request({
      url: endpoints.mandateAuthpayment.refundAuthPayment,
      baseUrl: "orders",
      method: endpoints.APIMethods.PUT,
      data: data
    })
    return response?.data
  } catch (error) {
    console.error("Error deleting CRM table data:", error)
    throw error
  }
}
export const getCommonChartsAPI = async (currentPage = 1, api, params) => {
  try {
    const response = await request({
      url: endpoints.reportModule[api], // Access the endpoint dynamically
      baseUrl: "reports",
      params: params,
      method: endpoints.APIMethods.GET,
    })

    return response
  } catch (error) {
    history.goBack()
    console.error("Error fetching search data:", error)

    throw error // Optional: rethrow the error for further handling
  }
}

export const fetchgetpayload = async (data) => {
  try {
    const response = await request({
      url: endpoints.systemConfigSettingsModule.getpayload, // Access the endpoint dynamically
      baseUrl: "reports",
      params: data,
      method: endpoints.APIMethods.GET,
    })

    return response
  } catch (error) {
    console.error("Error fetching search data:", error)

    throw error // Optional: rethrow the error for further handling
  }
}
export const fetchOptions = async (data) => {
  try {
    const response = await request({
      url: endpoints.systemConfigSettingsModule.typeOptions, // Access the endpoint dynamically
      baseUrl: "reports",
      data: data,
      method: endpoints.APIMethods.POST,
    })

    return response
  } catch (error) {
    console.error("Error fetching search data:", error)

    throw error // Optional: rethrow the error for further handling
  }
}
export const getSearchDataReconication = async (currentPage = 1, api, params) => {
  try {
    const response = await request({
      url: endpoints.reportModule[api], // Access the endpoint dynamically
      baseUrl: "reports",
      data: params,
      method: endpoints.APIMethods.POST
    })
    return response
  } catch (error) {
    console.error("Error fetching search data:", error)
    Toast({
      type: "error",
      message: "Failed to fetch search data. Please try again.",
    })
    throw error // Optional: rethrow the error for further handling
  }
}
export const getSubikshamReport = async (params) => {
  try {
    const response = await request({
      url: endpoints.reportModule.subhkshamReport, // Access the endpoint dynamically
      baseUrl: "reports",
      params: params,
      method: endpoints.APIMethods.GET,
    })

    return response
  } catch (error) {
    history.goBack()
    console.error("Error fetching search data:", error)

    throw error // Optional: rethrow the error for further handling
  }
}
export const getSponcer = async (params) => {
  try {
    const response = await request({
      url: endpoints.reportModule.sponcer, // Access the endpoint dynamically
      baseUrl: "reports",
      params: params,
      method: endpoints.APIMethods.GET,
    })

    return response
  } catch (error) {
    history.goBack()
    console.error("Error fetching search data:", error)

    throw error // Optional: rethrow the error for further handling
  }
}
export const fetchTicketsAPI = async (params) => {
  try {
    const response = await request({
      url: endpoints.customerModule.tickets(params.email), // Access the endpoint dynamically
      baseUrl: "crm",
      params: params,
      method: endpoints.APIMethods.GET,
    })

    return response
  } catch (error) {
    console.error("Error fetching search data:", error)

    throw error // Optional: rethrow the error for further handling
  }
}

export const fetchExportUsers = async (startDate, endDate) => {
  try {
    const response = await request({
      url: `/admin/export/user?startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "users",
      responseType: "blob",
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(
        new Blob([response.data])
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "users.csv");

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error("Error exporting users:", error);

    Toast({
      type: "error",
      message:
        error.response?.data?.message || "Error exporting users",
    });
  }
};
